import React from 'react';
import { DEFAULT_PAGE_SIZE, PAGINATION_SIZE_OPTIONS } from '../../constants/table.constants';
import _ from 'lodash';
import { Pagination as ACPAASPagination, Select } from '@acpaas-ui/react-components';

const Pagination = ({
  page = 1,
  totalElements = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  pageOptions = PAGINATION_SIZE_OPTIONS,
  disabled = false,
  isLoading,
  isEmpty,
  onChange = _.noop,
  className = ''
}) => {
  const allDisabled = disabled || totalElements === 0;
  const changeObject = (page, pageSize) => ({ page: page ? parseInt(page) : 0, size: parseInt(pageSize) });

  const changePageSize = (event) => {
    onChange(changeObject(1, event?.target?.value));
  };
  const changePage = (newPage) => {
    onChange(changeObject(newPage, pageSize));
  };

  if (!isLoading && isEmpty) {
    return null;
  }

  return (
    <nav className={`spo-m-pagination u-margin-top ${className}`}>
      <div className="u-display-flex">
        <Select size="small" disabled={allDisabled} onChange={changePageSize} options={pageOptions} value={pageSize} />
        <p>items per pagina</p>
      </div>
      <ACPAASPagination
        currentPage={page}
        itemsPerPage={pageSize}
        totalValues={totalElements}
        display="numbers"
        buttonType="a"
        onUpdate={changePage}
        styling="m-pagination--small m-pagination--outline u-bg-white"
      />
    </nav>
  );
};

export default Pagination;
